import { uniq, values } from 'lodash';
/*
// file format as requested -> standardized media type
export const REQUESTED_TO_IANA_GENERIC = {
    'xml':'application/xml',
    'application/ld+json':'application/ld+json',
    'application/json':'application/ld+json',
    'json':'application/ld+json',
    'jsonld':'application/ld+json'
};
//*/
// file format as requested to standardized media type appropriate for pathway data
export var REQUESTED_TO_IANA_FOR_PATHWAYS = {
    'application/vnd.biopax.rdf+xml': 'application/vnd.biopax.rdf+xml',
    'application/biopax.rdf+xml': 'application/vnd.biopax.rdf+xml',
    'application/biopax+xml': 'application/vnd.biopax.rdf+xml',
    'application/rdf+xml': 'application/vnd.biopax.rdf+xml',
    'biopax': 'application/vnd.biopax.rdf+xml',
    'application/owl+xml': 'application/vnd.biopax.rdf+xml',
    'owl': 'application/vnd.biopax.rdf+xml',
    'application/vnd.gpml+xml': 'application/vnd.gpml+xml',
    'application/gpml+xml': 'application/vnd.gpml+xml',
    'gpml': 'application/vnd.gpml+xml',
    'xml': 'application/vnd.gpml+xml',
    'application/xml': 'application/vnd.gpml+xml',
    'application/ld+json': 'application/ld+json',
    'application/json': 'application/ld+json',
    'json': 'application/ld+json',
    'jsonld': 'application/ld+json',
    'pvjson': 'application/ld+json',
    'application/pdf': 'application/pdf',
    'pdf': 'application/pdf',
    'image/png': 'image/png',
    'png': 'image/png',
    'image/svg+xml': 'image/svg+xml',
    'application/svg+xml': 'image/svg+xml',
    'svg': 'image/svg+xml',
    'text/genelist': 'text/genelist',
    'text/plain': 'text/genelist',
    'genelist': 'text/genelist',
    'text/pwf': 'text/pwf',
    'text/eugene': 'text/pwf',
    'eugene': 'text/pwf',
    'pwf': 'text/pwf'
};
// or at least types we may eventually support
export var SUPPORTED = uniq(values(REQUESTED_TO_IANA_FOR_PATHWAYS));
// convert from standardized format (as specified above) to
// the format used by the current (2014-06-09) WikiPathways API
// for the pathway
export var IANA_TO_WP_API_BODY = {
    'application/vnd.biopax.rdf+xml': 'owl',
    'application/vnd.gpml+xml': 'gpml',
    // TODO the WikiPathways API cannot currently return the pathway as JSON,
    // only the pathway metadata.
    //'application/ld+json':'json',
    'application/ld+json': 'gpml',
    'application/pdf': 'pdf',
    'image/png': 'png',
    'image/svg+xml': 'svg',
    'text/genelist': 'txt',
    'text/pwf': 'pwf'
};
// convert from standardized format (as specified above) to
// the format used by the current (2015-04-29) WikiPathways API
// for the response envelope
export var IANA_TO_WP_API_ENVELOPE = {
    'application/vnd.biopax.rdf+xml': 'xml',
    'application/xml': 'xml',
    'application/vnd.gpml+xml': 'xml',
    'application/ld+json': 'json',
    'text/genelist': 'text',
    'text/pwf': 'text'
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/media-types.ts
// module id = 63
// module chunks = 0